/**
 * @generated SignedSource<<7e94db783df2a52280227087efdfac67>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorDesignsQuickView_quickViewDisplay$data = {
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData" | "SeoLink_linkData">;
  };
  readonly paragraphAttributeNames: {
    readonly material: string | null;
    readonly style: string | null;
  } | null;
  readonly paragraphs: ReadonlyArray<{
    readonly key: string | null;
    readonly text: string | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCreators_quickViewDisplay">;
  readonly " $fragmentType": "SbSharedCreatorDesignsQuickView_quickViewDisplay";
};
export type SbSharedCreatorDesignsQuickView_quickViewDisplay$key = {
  readonly " $data"?: SbSharedCreatorDesignsQuickView_quickViewDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorDesignsQuickView_quickViewDisplay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorDesignsQuickView_quickViewDisplay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoButton_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "material",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCreators_quickViewDisplay"
    }
  ],
  "type": "QuickViewDisplayType",
  "abstractKey": null
};

(node as any).hash = "cd80fe6caba2a9fb58cb5a7f7e268349";

export default node;
